import { useUser } from 'context/user/User';
import React from 'react'
import GoogleLogin from 'react-google-login';
import { useNavigate } from 'react-router-dom';
import loginApi from 'api/requests/login';
import Button from 'components/_UI/Button';
import styled from 'styled-components';

export default function GoogleSignIn() {
    const { setUser } = useUser();
    const navigate = useNavigate();

    const responseGoogle = (response) => {
        const { accessToken, googleId, profileObj } = response;
        const payload = {
            accessToken,
            googleId,
            email: profileObj.email
        };

        registerUser(payload);
    }

    const registerUser = async (payload) => {
        try {
            const { data } = await loginApi.withGoogle(payload);
            localStorage.setItem('token', data.token);
            setUser(data);
            navigate('/home');
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <GoogleLogin
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            onSuccess={responseGoogle}
            onFailure={responseGoogle}
            cookiePolicy={'single_host_origin'}
            render={renderProps => (
                <Button
                    variant='secondary'
                    size='large'
                    onClick={renderProps.onClick}
                >
                    <StyledImg src='assets/images/google-logo.png' />
                    Entrar com google
                </Button>
            )}
        />
    )
}

const StyledImg = styled.img `
    width: 18px;
    vertical-align: bottom;
    margin-right: 6px;
`;